module.exports = __webpack_public_path__ + "assets/img/24@3x.dae5a32b.png";